<!-- SSHForm.vue -->
<template>
  <div>
    <b-form-group label="Auth Method" label-for="authMethod">
      <b-form-select
        id="authMethod"
        v-model="resource.authMethod"
        :options="authMethods"
        required
      ></b-form-select>
    </b-form-group>

    <b-form-group label="Username" label-for="username">
      <b-form-input
        id="username"
        v-model="resource.username"
        required
      ></b-form-input>
    </b-form-group>

    <!-- Show password field only if password auth is selected -->
    <b-form-group
      v-if="resource.authMethod === 'password'"
      label="Password"
      label-for="password"
    >
      <b-form-input
        id="password"
        v-model="resource.password"
        type="password"
        required
      ></b-form-input>
    </b-form-group>

    <!-- Show key file input if key-based auth is selected -->
    <b-form-group
      v-if="resource.authMethod === 'key'"
      label="Private Key"
      label-for="keyFile"
    >
      <b-form-textarea
        id="keyFile"
        v-model="resource.keyFile"
        placeholder="Paste your private key here"
        rows="5"
        required
      ></b-form-textarea>
    </b-form-group>

  </div>
</template>

<script>
export default {
  name: 'SSHForm',
  props: {
    resource: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      authMethods: [
        { value: 'password', text: 'Password' },
        { value: 'key', text: 'SSH Key' }
      ]
    }
  }
}
</script>
